import React from "react";
import isMobile from "ismobilejs";
import { connect } from "react-redux";
import { movil } from "../app-movil";
import { guardarDatosInconvenientes } from "./service.act";
import { callService, goTo } from "../tools";
import InconvenientesForm from "./inconvenientes.frm.js";
import InconvenientesWeb from "./inconvenientesWeb.frm.js";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';

const validacion = "Error";
const mensajeItim = "Ocurrió un error inesperado, comunícate a la línea GNP 55 5227 9000 para más información.";

const mapState = (state) => {
	return {
		loading: state.global.loading,
		conectaMovil: state.global.conectaMovil,
		sistema: state.registro.configuracion.sistema
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		alerta: (sTitulo, sMensaje, fnCerrar) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnCerrar });
		},
		registrarDatos(sTipo, sExtension, sLada, sTelefono) {
			dispatch(guardarDatosInconvenientes(sTipo, sExtension, sLada, sTelefono));
		},
		pasoCompleto: () => {
			dispatch({ "type": "REGISTRO_COMPLETO", completo: true });
		}
	};
};

class Inconvenientes extends React.Component {

	state = {
		showTooltip: false,
		mensaje: "",
		type: "",
		titulo: ""
	}

	getHerramienta = () => {
		return (isMobile.any === true) ? "APP" : "PORTAL";
	}

	submit = (data) => {
		let $this = this;
		let Extension = "";
		const herramienta = this.getHerramienta();

		if(!data.extension || data.extension === ""){
			Extension = data.lada; 
		}else{
			Extension = data.extension;
		}

		$this.props.loader(true);
		$this.props.registrarDatos(data.tipo, Extension, data.lada, data.telefono);

		let llamaServicio = new callService({
			service: "registro.datosInconvenientes",
			secure: true,
			data: {
				tipoTelefono: data.tipo,
				extension: Extension,
				lada: data.lada,
				telefono: data.telefono,
				llamar: data.llamar,
				sistema: this.props.sistema
			}
		});

		return llamaServicio.execute().then((respuesta) => {
			$this.props.loader(false);
			$this.props.pasoCompleto();

			if (data.llamar && herramienta === "APP") {
				if ($this.props.conectaMovil === true) {
					movil("registroAsistido", { "proceso": "llamada", "numero": "8004009000,7", "return": "login" });
				} else {
					goTo("gnp/login");
					window.location.href = "tel://018004009000";
				}
			} else {
				movil("registroAsistido", { "return": "login" });
				goTo("gnp/login");
			}
		}).catch((error) => {
			console.log("Error", error);
			$this.props.loader(false);
			this.errorRespuestaInconvenientes(error);
		});
	}

	errorRespuestaInconvenientes = (error) => {
		const herramienta = this.getHerramienta();
		const mensaje = { "return": "home" };

		if(herramienta === "APP"){
			if(error.message.codigoError.includes("ITIM")){
				$this.props.alerta("IMPORTANTE", mensajeItim, function () {
					movil("", mensaje);
					goTo("gnp/login");
				});
			}else{
				$this.props.alerta("IMPORTANTE", error.message.mensaje, function () {
					movil("", mensaje);
					goTo("gnp/login");
				});
			}
		}
		else{
			if(error.message.codigoError.includes("ITIM")){
				this.muestraTooltip(true, 'error', validacion, mensajeItim);
				this.setTimeout(()=>{
					goTo("gnp/login");
				}, 5000);
			}else{
				this.muestraTooltip(true, 'error', validacion, error.message.mensaje);
				this.setTimeout(()=>{
					goTo("gnp/login");
				}, 5000);
			}
			
		}
	}

	muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
	}

	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}

	render() {
		return <div>
			<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
				show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
			</ModalSintillo>

			{this.props.conectaMovil === true ?
				<InconvenientesForm onSubmit={this.submit} /> :
				<InconvenientesWeb onSubmit={this.submit} />
			}
		</div>
	}
}

export default connect(mapState, mapDispatch)(Inconvenientes);


// WEBPACK FOOTER //
// ./src/gnp-registro-asistido/inconvenientes.cmpt.js